import { render, staticRenderFns } from "./PhotoBookImageUploader.vue?vue&type=template&id=68c42c36"
import script from "./PhotoBookImageUploader.vue?vue&type=script&lang=js"
export * from "./PhotoBookImageUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports